import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, message, Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { useSaleRoDetailModel } from "./saleRoDetailModel";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../saleRoTypes";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { ITopType } from "@/types/ScmTypes";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { YhBut } from "@/components/YhButton";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const TableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {

    const {
        setAddModalVisible,
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataSource,
        detailDetailList,
        modelScreenMethod,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow
    } = useSaleRoDetailModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }

    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            setAddModalVisible(true)
        })
    }
    const isEditable = (status: string) => {
        if (mode === "look") return false;
        if (mode === "add") return true;

        if (mode === "edit" &&
            status === DictCodeEnmu.SALE_RETURN_STATUS_SETTLE ||
            status === DictCodeEnmu.SALE_RETURN_STATUS_STOCK_IO || status === "sale-return-status.paying"
        ) {
            return false
        }
        return true;
    }
    const action =
        <>
            {(mode !== "look" ? (mode === "add" || !(detailEditForm.status === "sale-return-status.settle" || detailEditForm.status === "sale-return-status.stock-io")) : false) && <>
                <YhAuth resCode={ResourceAuthEnum.S_R_ED_ADD_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={switchModelViaible}
                    >新增商品</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_R_ED_DEL_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => { detailDetailList(mode) }}
                    >删除商品</Button>
                </YhAuth>

            </>}
        </>

    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 120,
            dataIndex: 'saleCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any, index: number) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'saleNum',
        }, {
            title: '销售单价',
            width: 100,
            dataIndex: 'salePrice',
        }, {
            title: '折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + '%'
        }, {
            title: '退货数量',
            width: 100,
            dataIndex: 'num',
            editable: isEditable(detailEditForm.status as string),
        }, {
            title: '退货单价',
            width: 100,
            dataIndex: 'price',
            editable: isEditable(detailEditForm.status as string),
        }, {
            title: '退货折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + '%'
        }, {
            title: '退货折扣金额',
            width: 100,
            dataIndex: 'discountAmount',
        }, {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'rdecreaseAmount'
        }, {
            title: '退货金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '已退数量',
            width: 100,
            dataIndex: 'sreturnNum',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isEditable(detailEditForm.status as string),
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isEditable(detailEditForm.status as string)
                && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "saleReturn", "roleCodes": roles };
        return getRoleColumns("saleReturn", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = (row: IDetailList) => {
        let { num, price, sreturnNum, saleNum, discountRate, salePrice, rdecreaseAmount } = row as { salePrice: number, num: number, price: number, sreturnNum: number, saleNum: number, discountRate: number, rdecreaseAmount: number }
        saleNum = + formatNum(saleNum)
        sreturnNum = + formatNum(sreturnNum)
        price = +formatNum(price)
        if (price > +salePrice) {
            message.warning(`修改价格不应大于销售价格${salePrice}`)
            price = +formatNum(salePrice)
        }
        // price = +formatIntPoint1(salePrice, price, `修改价格不应大于销售价${salePrice}`);
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        num = +formatIntPoint(num, saleNum - sreturnNum, "退货数量>销售数量")

        let newRow = {
            ...row,
            num,
            price,
            amount: +formatNum(((num * price * discountRate) / 100) - rdecreaseAmount),
            discountAmount: +formatNum((num * price * discountRate) / 100)
        }
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailId === item.detailId);
        const item = newData[index];

        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }

    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.detailId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}